import Model from '@/common/models/common.model';
import { SECURITY_GROUP_DEFAULT_NAME } from '@/common/constants/networks.constants';
import { SecurityGroup as SecurityGroupSchema } from '@schema';

export default class SecurityGroup extends Model {
  declare attributes: SecurityGroupSchema;

  get description(): string {
    return this.attributes.description;
  }

  get id(): string {
    return this.attributes.id;
  }

  get name(): string {
    return this.attributes.name;
  }

  get projectId() {
    return this.attributes.project_id;
  }

  get domainId() {
    return this.attributes.domain_id;
  }

  get securityGroupRules() {
    return this.attributes.security_group_rules || [];
  }

  get isDeletable() {
    return this.attributes.name !== SECURITY_GROUP_DEFAULT_NAME && !this.isSystem;
  }

  get ingressRules() {
    return this.securityGroupRules.filter(rule => rule.direction === 'ingress');
  }

  get egressRules() {
    return this.securityGroupRules.filter(rule => rule.direction === 'egress');
  }
}
